import * as React from 'react';
import { Button, Typography } from '../../../ui';
import { makeStyles, Dialog, Grid, Theme } from '@material-ui/core';
import * as Store from '../../Store';
import { connect } from 'react-redux';
import { getAppConfig } from '../../selectors/basketSelectors';
import flipDishLogo from '../../assets/images/flipDishLogo.svg';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: 0
  },
  link: {
    color: 'inherit'
  },
  container: {
    maxWidth: '400px',
    padding: '28px 24px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '328px'
    }
  },
  header: {
    fontWeight: 'bold',
    lineHeight: '21px',
    paddingBottom: '16px'
  },
  title: {
    lineHeight: '21px',
    paddingBottom: '16px'
  }
}));

type StateProps = {
  storeBrandName: string;
  termsLink: string;
  privacyPolicyUrl: string;
};

type Props = {
  onOkClick: () => void;
  translate: any;
  isPaymentWarning: boolean;
} & StateProps;

const SecureWarningModalComponent = (props: Props) => {
  const classes = useStyles({});
  const { translate, isPaymentWarning } = props;

  return (
    <Dialog open onClose={props.onOkClick} classes={{ paper: classes.root }}>
      <div className={classes.container}>
        <Typography variant="h5" className={classes.header}>
          {`${translate('we_use')} ${translate('Flipdish')} - ${translate('global_secure_text')}.`}
        </Typography>
        <Typography variant="h5" className={classes.title}>
          {translate('As_you_previously_ordered_from', { name: props.storeBrandName })}
        </Typography>

        <Typography variant="h5" className={classes.title}>
          {translate('We_can_only_view_your_information_when_you_place_an_order')}
        </Typography>

        <Typography variant="h5" className={classes.title}>
          {translate('view_flipdish')}{' '}
          <a target="_blank" href={props.termsLink} className={classes.link}>
            <span style={{ textDecoration: 'underline' }}>{translate('terms_of_services')}</span>
          </a>
          {' & '}
          <a target="_blank" href={props.privacyPolicyUrl} className={classes.link}>
            <span style={{ textDecoration: 'underline' }}>{translate('Privacy_policy')}</span>
          </a>
          .
        </Typography>
        <Grid container justify="center" style={{ paddingBottom: '20px' }}>
          <img src={flipDishLogo} style={{ width: '92px', height: '25px' }} alt="Flipdish logo" />
        </Grid>
        <Button
          style={{ width: '100%' }}
          variant="contained"
          color="primary"
          onClick={props.onOkClick}
        >
          {translate('OK')}
        </Button>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (s: Store.State): StateProps => {
  const config = getAppConfig(s);
  return {
    storeBrandName: config?.BrandName,
    termsLink: 'https://www.flipdish.com/flipdish-consumer-terms-and-conditions/',
    privacyPolicyUrl: 'https://www.flipdish.com/privacy-policy/'
  };
};

export const SecureWarningModal = connect(mapStateToProps)(SecureWarningModalComponent);
